'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _PromotionBannerContainer = require('pricing-pages-unified-ui/components/banners/PromotionBannerContainer');

var _PromotionBannerContainer2 = _interopRequireDefault(_PromotionBannerContainer);

var _PartnerProgramBanner = require('pricing-pages-unified-ui/components/banners/PartnerProgramBanner');

var _PartnerProgramBanner2 = _interopRequireDefault(_PartnerProgramBanner);

var _ActiveQuoteBanner = require('./ActiveQuoteBanner');

var _ActiveQuoteBanner2 = _interopRequireDefault(_ActiveQuoteBanner);

var _EnvironmentWrapper = require('pricing-pages-unified-ui/components/EnvironmentWrapper');

var _EnvironmentWrapper2 = _interopRequireDefault(_EnvironmentWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BannerSection = function BannerSection(_ref) {
  var hub = _ref.hub,
      hasTitleComponent = _ref.hasTitleComponent;
  return _react2.default.createElement(
    _react.Fragment,
    null,
    _react2.default.createElement(_PromotionBannerContainer2.default, { hub: hub, hasTitleComponent: hasTitleComponent }),
    _react2.default.createElement(_EnvironmentWrapper2.default, {
      authedNode: _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(_PartnerProgramBanner2.default, null),
        _react2.default.createElement(_ActiveQuoteBanner2.default, { hub: hub })
      )
    })
  );
};

BannerSection.propTypes = {
  hub: _react.PropTypes.string.isRequired,
  hasTitleComponent: _react.PropTypes.bool.isRequired
};

exports.default = BannerSection;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/banners/BannerSection.js
// module id = 250
// module chunks = 3 4